import {TextField} from "@material-ui/core";
import {useTranslation} from "react-i18next";

export const HourRange = ({from, to, onUpdate}) => {

	const { t } = useTranslation();

    let hours = [];
    for (let i = 0; i <= 24; i++) {
        hours.push({ value: i, label: i + ":00"});
    }

    return (
        <>
        <TextField
            label={t('From')}
            select
            SelectProps={{ native: true }}
            value={from}
            onChange={e => onUpdate('from', e.target.value)}
        >
            <option></option>
            {hours.map((item) => (
                <option key={ item.value } value={ item.value }>{ item.label}</option>
            ))}
        </TextField>
        <TextField
            label={t('To')}
            select
            SelectProps={{ native: true }}
            value={to}
            onChange={e => onUpdate('to', e.target.value)}
        >
            <option></option>
            {hours.map((item) => (
                <option key={ item.value } value={ item.value }>{ item.label}</option>
            ))}
        </TextField>
        </>);

}